export default "__VITE_ASSET__NFVNUT20__"